import React from 'react';
import clsx from 'clsx';
import { v4 as uuid } from 'uuid';
import { Collapse } from 'react-collapse';
import { PlusIcon, Typography, getTypographyDefaultColor } from '@ag1/ui';
import { ImageAndExpandableListV2, SanityKeyed, Substance } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import styles from './SubstancePopup.module.scss';

type ListItemProps = {
  theme: ImageAndExpandableListV2['theme'];
  isOpen: boolean;
  onToggle: () => void;
};

export const ListItem = ({
  listItemContent,
  listItemHeadline,
  isOpen,
  onToggle,
  theme
}: ListItemProps & SanityKeyed<Substance>) => (
  <div className={clsx(styles.listItem, isOpen && styles.active, getThemeCSSClass(theme))}>
    <div className={styles.row}>
      <div
        className={styles.listToggle}
        role="button"
        onClick={onToggle}
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            onToggle();
          }
        }}>
        <Typography
          variant="body"
          size="2"
          component="h4"
          weight="700"
          noPadding
          color={getTypographyDefaultColor(theme)}
          className={styles.listItemHeadline}>
          {listItemHeadline}
        </Typography>
        <span className={clsx(styles.icon, getThemeCSSClass(theme))}>
          <PlusIcon />
        </span>
      </div>
    </div>
    <Collapse isOpened={isOpen}>
      <div className={clsx(styles.contentWrap, isOpen && styles.isOpen)}>
        {listItemContent &&
          listItemContent.map((text) => (
            <Typography
              key={`${uuid}`}
              variant="body"
              size="2"
              component="div"
              noPadding
              className={styles.text}
              color={getTypographyDefaultColor(theme)}>
              {text}
            </Typography>
          ))}
      </div>
    </Collapse>
  </div>
);
